import React from 'react';
import { motion } from 'framer-motion';
import { ChevronRight } from 'lucide-react';
export const CTAButton = ({
  children,
  onClick,
  className = ''
}: {
  children: ReactNode;
  onClick?: () => void;
  className?: string;
}) => {
  const handleClick = () => {
    window.open('https://flujovital360.com/cart/45985023361220:1', '_blank');
    onClick?.();
  };
  return <motion.button whileHover={{
    scale: 1.02,
    boxShadow: '0 0 20px rgba(212, 168, 83, 0.4)'
  }} whileTap={{
    scale: 0.98
  }} onClick={handleClick} className={`relative overflow-hidden group bg-gradient-to-r from-prime-gold to-prime-goldHover text-prime-black font-bold py-4 px-8 rounded-sm text-lg md:text-xl uppercase tracking-wide flex items-center justify-center w-full max-w-2xl mx-auto shadow-[0_0_15px_rgba(212,168,83,0.2)] transition-all duration-300 ${className}`} data-id="element-159">
      <span className="relative z-10 flex items-center gap-2" data-id="element-160">
        {children}
        <ChevronRight className="w-6 h-6 group-hover:translate-x-1 transition-transform" data-id="element-161" />
      </span>
      <div className="absolute inset-0 bg-white opacity-0 group-hover:opacity-20 transition-opacity duration-300" data-id="element-162" />
    </motion.button>;
};
export const SectionWrapper = ({
  children,
  className = '',
  id = ''
}: {
  children: ReactNode;
  className?: string;
  id?: string;
}) => {
  return <section id={id} className={`py-20 md:py-32 px-4 relative ${className}`} data-id="element-163">
      <motion.div initial={{
      opacity: 0,
      y: 30
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      margin: '-100px'
    }} transition={{
      duration: 0.8,
      ease: 'easeOut'
    }} className="max-w-4xl mx-auto relative z-10" data-id="element-164">
        {children}
      </motion.div>
    </section>;
};
export const GoldDivider = () => <div className="w-full flex justify-center py-8" data-id="element-165">
    <div className="w-24 h-[1px] bg-gradient-to-r from-transparent via-prime-gold to-transparent opacity-50" data-id="element-166" />
  </div>;